// USA
export const locale = {
  lang: "th",
  data: {
    APP_NAME: "Edvance",
    TRANSLATOR: {
      SELECT: "Select your language",
    },
    MENU: {
      //Main Menu
      COURSES_SECTION_TITLE: "Courses",
      COURSES: "Courses",
      COURSE_CATEGORIES: "Course Categories",
      LESSONS: "Lessons",
      SEMESTER: "Semester",
      EDUCATIONS: "Educations",
      EDUCATION_LEVELS: "Education Levels",


      EXAMS_SECTION_TITLE: "Exams",
      QUESTIONS: "Questions",
      QUESTION_LEVELS: "Question Levels",
      EXAM_GROUP: "Exam Group",
      EXAMINATION_REPORT: "Examination Report",

      CONTENT_SECTION_TITLE: "Content",
      VIDEO: "Video",
      BLOGS: "Blogs",
      BLOG_CATEGORIES: "Blog Categories",
      REVIEW: "Review",

      USERS_SECTION_TITLE: "Users",
      STUDENT: "Student",
      PARENT: "Parent",
      TUTOR: "Tutor",
      ADMIN: "Admin",

      PAYMENT_SECTION_TITLE: "Payment",
      BANK_ACCOUNT: "Bank Account",
      DISCOUNTS: "Discounts",
      TRANSACTIONS: "Transactions",
      FINANCIAL_REPORT: "Financial Report",

      SETTINGS_SECTION_TITLE: "Settings",
      WEB_ADMIN: "Web Admin",

      DASHBOARD: "หน้าหลัก",
      REPORTS: "รายงาน",
      SETTINGS: "ตั้งค่า",
      SCHEDULE_MANAGEMENT:"การจัดการคำขอสอนชดเชย",
      TEACH_COMPENSATION:"การจัดการคำขอสอนชดเชย",

      TEACH_COMPENSATION_REQUEST:"คำขอสอนชดเชย",
      SUBJECT_MANAGEMRNT:"การจัดการรายวิชา",


      //Sub & Children
      JOB_CREDIT_REP: "Job เครติด (REP)",
      CUSTOMER_STATS: "สถิติลูกค้า",
      CUSTOMER_CREDITS: "ลูกค้าเครดิต",
      ABNORMAL_CUSTOMER_CREDITS: "Job ลูกค้าเครดิตผิดปกติ",
      INSURANCE_STAT: "สถิติบริษัทประกันภัย",
      INSURANCE_CUSTOMER: "บริษัทประกันภัย",
      ABNORMAL_INSURANCE_CUSTOMER: "Job บริษัทประกันภัยผิดปกติ",

      CLAIM_SUMMARY: "สรุปงานเคลม",
      AFI: "รายการ AFI",
      AFC: "รายการ AFC",
      ACP: "รายการ ACP",
      FREE: "รายการ FREE",
      CAMPAIGN_JOB: "รายการ Campaign",

      PART_JOB_LIST: "งานอ่ะไหล่",
      BACK_ORDER: "Back Order",

      UPLOAD_REPORT_FILE: "รายงานอัพโหลดไฟล์",

      CREDIT_DEBTOR_SETTING: "ตั้งค่าลูกหนี้เครดิต",
      INSURANCE_COMPANY: "บริษัทประกันภัย",
      DEALER_BRANCH: "ตัวแทนจำหน่าย/สาขา",
      STAFF: "ข้อมูลพนักงาน",
      LINE_NOTIFICATION_SETTINGS: "ตั้งค่า Line แจ้งเตือน",
      PENDING_JOB_SETTING: "ตัวเลือกติดตามงานค้าง",
      DEBTOR_JOB_SETTING: "ตัวเลือกติดตามลูกหนี้",
      SERIES: "รุ่นรถ",
      USER: "ผู้ใช้",
      NOTIFICATION: "การแจ้งเตือน",
      TOPSERV: "Topserv",
      SERVER_MAINTENANCES: "Server Maintenances",
      HEALTH_CHECK: "Health Check",

      JOB: "งาน",
      INSURANCE: "ประกันภัย",
      CUSTOMER_GROUP: "กลุ่มลูกค้า",
      CAR: "รถยนต์",
      CAMPAIGN: "แคมเปญ",
      DISCOUNT: "ส่วนลด",
      ROLE: "บทบาท",
    },
    USER_MENU: {
      PROFILE: "โปรไฟล์",
      PURCHASE_ORDER: "ประวัติคำสั่งซื้อ",
      SIGN_IN: "ลงชื่อเข้าใช้",
      SIGN_OUT: "ออกจากระบบ",
      CLASS_ROOM: "ห้องเรียน",
    },
    APP: {
      APP_NAME: "Edvance",
      SOCIAL_MEDIA: "Social Media",
      ACCOUNT_PROFILE: "ข้อมูลส่วนตัว",
      DRAFT: "แบบร่าง",
      WAITING_DOC: "เอกสารรอส่ง",
      IN_PROGRESS: "กำลังดำเนินการ",
      HISTORY: "ประวัติ",
      ATTACHMENTS: "ไฟล์แนบ",
      DOC_NO: "เลขที่",
      DATE: "วันที่",
      DOCUMENT_NO: "เลขที่เอกสาร",
      TIMELINE: "Timeline",
      ISSUE_NO: "เลขที่หนังสือ",
      SUBJECT: "เรื่อง",
      DEAR: "เรียน",
      NAME_TITLE: "คำนำหน้าชื่อ",
      NAME: "ชื่อ",
      FIRST_NAME: "ชื่อ",
      LAST_NAME: "นามสกุล",
      NICKNAME: "ชื่อเล่น",
      ACADEMY: "สถานศึกษา",
      TYPE: "ประเภท",
      PHONE: "เบอร์โทรศัพท์",
      DOB: "วัน/เดือน/ปี เกิด",
      DATE_FORMAT: "วัน/เดือน/ปี",
      YEAR: "ปี",
      MONTH: "เดือน",
      DAY: "วัน",
      TOPIC: "หัวข้อ",
      FILE_NAME: "ชื่อไฟล์",
      FILE_PLACEHOLDER: "เลือกหรือลากและวางไฟล์ลงที่นี่",
      FILE_PLACEHOLDER_ADD_ON: "รองรับไฟล์นามสกุล PDF",
      FILE_PLACEHOLDER_2: "ลากและวางไฟล์ลงที่นี่หรือ",
      UPLOADED_FILE: "ไฟล์ที่อัปโหลด",
      REMARK: "เหตุผล",
      BY: "โดย",
      TEL: "โทร",
      PASS: "ผ่าน",
      FAIL: "ไม่ผ่าน",
      CURRENT_INFORMATION: "ข้อมูลปัจจุบัน",
      FULL_NAME: "ชื่อ-สกุล",
      SEARCH_USER_PLACEHOLDER: "ค้นหาชื่อ, อีเมล",
      SEARCH_PLACEHOLDER_TRACKING: "ค้นหาหมายเลข",
      EMAIL: "อีเมล",
      GENERAL_INFORMATION: "ข้อมูลทั่วไป",
      CONTACT_INFORMATION: "ข้อมูลการดิดต่อ",
      PLACE: "สถานที่",
      START_TIME: "เวลาเริ่มต้น",
      END_TIME: "เวลาสิ้นสุด",
      TOPIC_NAME: "ชื่อหัวข้อ",
      ADD: "เพิ่ม",
      TIME_FORMAT: "ชั่วโมง:นาที",
      HOUR: "ชั่วโมง",
      MINUTE: "นาที",
      SECOND: "วินาที",
      TIME: "เวลา",
      LOCATION: "สถานที่",
      NOTE: "เหตุผล",
      REJECT: "ปฏิเสธ",
      WAITING: "รอตอบรับ",
      APPROVE: "อนุมัติ",
      COMMENT: "ความคิดเห็น",
      DETAIL: "รายละเอียด",
      WAITING_FOR_APPROVAL: "รอการอนุมัติ",
      APPROVED: "อนุมัติแล้ว",
      INLINE_SEARCH: "ค้นหา:",
      YES: "ใช่",
      NO: "ไม่ใช่",
      NO_EVENTS: "ไม่มีกิจกรรม",
      NO_ITEMS: "ไม่มีรายการ",
      NO_ITEMS_FOUND: "ไม่มีรายการแสดง",
      NO_FILE_UPLOAD: "ไม่มีไฟล์ที่อัปโหลด",
      NO_COMMENTS: "ไม่มีความคิดเห็น",

      SLOT_TIMES: "ช่วงเวลา",
      PLEASE_COMMENT: "กรุณากรอกคำแนะนำ",
      USER: "รายชื่อผู้ใช้",

      LOADING: "กำลังโหลด",
      PROCESSING: "กำลังประมวลผล",

      // REPORTS
      DATE_PERIOD: "วัน",
      MONTH_PERIOD: "เดือน",
      YEAR_PERIOD: "ปี",
      INLINE_DATE_RANGE: "ช่วงวันที่:",
      INLINE_DATE: "วันที่:",
      INLINE_MONTH: "เดือน:",
      INLINE_YEAR: "ปี:",
      TO: "ถึง",
      START_DATE: "วันที่เริ่มต้น",
      END_DATE: "วันที่สิ้นสุด",
      ITEMS: "รายการ",

      TEACHER: "ผู้สอน",
      WELCOME: "ยินดีต้อนรับ",
      BAHT: "บาท",
      PAY: "ชำระเงิน",
      CANCEL_ORDER: "ยกเลิกรายการ",
      COURSE_DISCOUNT: "ส่วนลดคอร์ส",
      TOTAL_PRICE: "รวมทั้งหมด",
      AMOUNT: "จำนวน",
      COURSE_REVIEWS: "รีวิวจากผู้เรียน",
      ENROLL: "สมัครเรียน",
      ADD_CART: "เพิ่มลงตะกร้า",
      COURSE_OPTIONS: "สิ่งที่มีในคอร์ส",
      DURATION: "ระยะเวลาเรียน",
      VIDEO_DURATION_EXTRA: "ชั่วโมงส่วนเพิ่ม",
      COURSE_VIDEO: "วิดีโอการสอน",
      EXAMPLE: "แบบฝึกหัด",
      POST_EXAMPLE: "แบบทดสอบหลังเรียน",
      COURSE_DETAIL: "รายละเอียดคอร์ส",

      BROWSE_IMAGE: "เลือกรูป",
      RESET_PASSWORD: "รีเซ็ตรหัสผ่าน",
      CHANGE_PASSWORD: "เปลี่ยนรหัสผ่าน",
      OLD_PASSWORD: "รหัสผ่านเก่า",
      PASSWORD_CONFIRMATION: "ยืนยันรหัสผ่าน",
      NEW_PASSWORD: "รหัสผ่านใหม่",
      NEW_PASSWORD_CONFIRMATION: "ยืนยันรหัสผ่านใหม่",
      NEW_PASSWORD_REQUIRED: "กรุณาตั้งรหัสผ่านใหม่เพื่อดำเนินการ",

      COURSES: "คอร์สเรียน",
      STUDENT: "นักเรียน",
      BUY_NOW: "Buy Now",
      STUDENT_REVIEWS: "รีวิวจากน้องๆ",

      SHOW_ALL: "ดูทั้งหมด",
      NO_DURATION: "ไม่มี",
      NO_EXPIRATION: "ไม่มีกำหนด",

      DISCOUNT: "ส่วนลด",
      DISCOUNT_LABEL: "กรอกโค้ดส่วนลด",
      DISCOUNT_SHORT_LABEL: "ส่วนลด",
      DISCOUNT_PLACEHOLDER: "ส่วนลด (ใส่โค้ดส่วนลด)",
      USE_CODE: "ใช้โค้ด",

      TEACH_BY: "สอนโดย",
      COURSE_DESC: "รายละเอียดบทเรียน",
      COURSE_BENEFITS: "คุณจะได้เรียนอะไรบ้าง",
      VIDEOS: "วิดีโอ",
      LESSON: "บทเรียน",
      NO_LESSON: "ไม่มีบทเรียน",

      DESCRIPTION: "คำอธิบาย",

      SEND_EMAIL_DESC:
        "ระบบได้ส่งอีเมลไปยังที่อยู่อีเมลของท่านเรียบร้อยแล้ว กรุณาตรวจสอบอีเมลที่ท่านได้รับ",

      //Examination
      BACK: "ย้อนกลับ",
      NEXT: "ไปต่อ",

      SCORE: "คะแนน",
      SCORE_RESULT: "คะแนนที่ทำได้",
      EXAM_ITEM: "ข้อ",
      EXAM_ITEM_PER: "ข้อละ",
      CORRECT_ITEM: "จำนวนข้อที่ทำได้",
      CORRECT_ANS: "ตอบถูก",
      WRONG_ANS: "ตอบผิด",
      SKIP_ANS: "ไม่ตอบ / ข้าม",

      CORRECT_RESULT: "การตอบคำถาม",
      WRONG_RESULT: "ตอบถูกต้อง",
      SKIP_RESULT: "ไม่ตอบเลย",
      NOT_FOUND_RESULT: "ไม่มีผลการทดสอบของบทเรียน",

      FASTEST_ACCURACY: "เร็วที่สุด",
      SLOWEST_ACCURACY: "ช้าที่สุด",
      TOTAL_ACCURACY: "ทั้งหมด",

      CORRECT_ACCURACY: "ความถูกต้อง / ความแม่นยำ",
      SPEED_TIMER: "ความเร็ว / เวลาในการตอบต่อข้อ",

      CONCERN: "คำแนะนำ",
      NO_CONCERN: "ไม่มีคำแนะนำ",

      ADD_CART_SUCCESS: "เพิ่มใส่ตะกร้าเรียบร้อย",
      DISCOUNT_CODE: "รหัสส่วนลด",

      //Parent Course
      SEARCH_COURSE: "ค้นหาคอร์สเรียน",
      PARENT_COURSE: "รายการคอร์สเรียนที่ผู้ปกครองได้ซื้อไว้",
      WAIT_ACTIVE: "รอเปิดใช้งาน",
      INACTIVE: "ยังไม่ใช้งาน",
      NO_COURSE_ACTIVE: "รายการคอร์สยังไม่เปิดใช้งาน",
      GIVE_COURSE: "ให้คอร์ส",
      RECEIVED_STUDENT: "นักเรียนที่ได้รับ",

      COURSE_MANAGE: "จัดการคอร์สให้กับนักเรียน",
      AVAILABLE_COURSE: "จำนวนคอร์สที่เหลือ",

      ALREADY_HAVE_COURSE: "นักเรียนมีคอร์สนี้แล้ว",
      CANCEL_GIVE_COURSE: "ยกเลิกการให้คอร์สเรียบร้อย",
      GIVE_COURSE_SUCCESS: "ให้คอร์สเรียบร้อย",

      //Parent Menu
      PARENT_LIST: "รายการผู้ปกครอง",
      PARENT_CONNECTION: "เชื่อมต่อข้อมูลระหว่างนักเรียนกับผู้ปกครอง",
      PARENT_INVITATION: "ลิงค์คำเชิญผู้ปกครอง",
      FILL_INVITATION: "กรอกลิงค์คำเชิญนักเรียน",
      CONTACT: "ติดต่อ",
      PERSON: "คน",
      CARETAKER: "ผู้ดูแล",
      TAKING_CARE: "กำลังดูแล",

      COPY_INVITED: "คัดลอกลิงค์คำเชิญผู้ปกครองเรียบร้อย",
      ADD_STUDENT_SUCCESS: "เพิ่มนักเรียนสำเร็จ",
      ADD_STUDENT_FAILED: "เพิ่มนักเรียนไม่สำเร็จ",
      INVALID_CODE: "ลิงค์คำเชิญไม่ถูกต้อง",
      DISCONNECTED: "ยกเลิกเชื่อมต่อสำเร็จ",

      //User Password
      PASSWORD_MANAGEMENT: "จัดการรหัสผ่าน",
      CHANGE_RESET_PASSWORD: "แก้ไขและรีเซ็ทรหัสผ่าน",
      SAVE_CHANGE: "บันทึกการเปลี่ยนแปลง",
      RESET_NEW_PASSWORD: "รีเซ็ตรหัสผ่านใหม่",
      SEND_REQ_PASSWORD: "ส่งคำขอรีเซ็ทรหัสผ่าน",
      PASSWORD_REQ_DESC1:
        "อีเมลสำหรับรีเซ็ตรหัสผ่านใหม่จะถูกส่งไปยังอีเมลปัจจุบันของคุณ",
      PASSWORD_REQ_DESC2: "กรุณาตรวจสอบความถูกต้องของอีเมลก่อนดำเนินการ",

      //Purchase Order
      MY_ORDER: "คำสั่งซื้อของฉัน",
      ORDER_DATE: "วันที่สั่งซื้อ",
      ORDER_ITEM: "รายการคอร์สที่ซื้อ",

      TRANSACTION_SUMMARY: "สรุปยอด",
      SUB_TOTAL: "ราคารวม",
      PAY_BY: "ชำระผ่าน",
      BANK_TRANSFER: "โอนชำระผ่านธนาคาร",
      APPROVE_PROCESS: "กำลังตรวจสอบหลักฐาน",
      ACCOUNT_NAME: "ชื่อบัญชี",
      ACCOUNT_NO: "เลขที่บัญชี",
      ATTACH_SLIP: "แนบรูปหลักฐานชำระเงิน",
      SUBMIT_PAYMENT: "ยืนยันชำระเงิน",
      CANCEL_PAYMENT: "ยกเลิกคำสั่งซื้อ",
      ORDER_APPROVED: "ตรวจสอบเรียบร้อย",
      ORDER_CANCELED: "ยกเลิกแล้ว",
      SUBMIT_PAYMENT_DONE: "ยืนยันการชำระสำเร็จ!",
      CANCEL_PAYMENT_DONE: "ยกเลิกคำสั่งซื้อสำเร็จ!",

      DETAILS: "เนื้อหา",
      CATEGORIES: "หมวดหมู่",
      SEARCH: "ค้นหา",
      BLOG: "บทความ",
      SEARCH_BLOG: "ค้นหาบทความ",
      TOTAL_BLOG: "บทความทั้งหมด",
      PUBLIC: "เผยแพร่",
      RECENT_BLOG: "บทความล่าสุด",
    },

    LANDING_PAGE: {
      ONLINE_COURSE: "คอร์สเรียนออนไลน์",
      ADVICE_BUTTON: "สอบถามคอร์สเรียน-ขอทดลองเรียน",
      BANNER_VISION: {
        LINE_1: "ภาษาอังกฤษ",
        LINE_2: "ง่ายกว่าที่คิด",
        LINE_3: "ถ้าเรียนแบบถูกวิธี",
        LINE_4: "ฉีกกรอบการเรียนภาษาอังกฤษแบบเดิมๆ",
        LINE_5: "เรียนสนุก เป็นระบบ จบแล้วเชื่อมโยงเป็น",
        LINE_6: "ใช้งานได้จริง!",
      },
      COURSE_CATEGORY: "หมวดหมู่คอร์สเรียน",
      COURSE_CATEGORY_DESC:
        "ถ้ายังไม่สามารถตัดสินใจได้ว่าจะเลือกคอร์สเรียนออนไลน์ไหน เรามีตัวเลือกหมวดหมู่คอร์สเรียนที่เหมาะกับคุณ",
      MORE_COURSE: "ดูคอร์สทั้งหมด",
      WHY_WISE: "ทำไมต้องเรียนกับเรา",

      OUR_COURSE: "คอร์สเรียนของเรา",
    },
    ABOUT_US: {
      ABOUT: {
        PARAGRAPH_1:
          "เราเล็งเห็นปัญหาที่น้องๆ หลายคนเจอในการเรียนภาษาอังกฤษ\nคือการท่องจำที่ไม่เข้าใจหลายครั้งวิธีเรียนแบบเดิมๆ\nแต่ที่นี่ต่างออกไป! เพราะครูของเราไม่เพียงแค่เป็นผู้สอน\nที่มีประสบการณ์กว่า 10 ปี แต่เข้าใจปัญหาที่น้องๆ กำลังเผชิญอยู่\nเราได้สรุปและสร้างเทคนิคทำให้ภาษาอังกฤษกลายเป็นเรื่องง่าย\nไม่ใช่แค่ท่องจำ",
        PARAGRAPH_2:
          "เราอยากให้น้องๆให้โอกาสตัวเอง\nได้ลองเรียนรู้ภาษาอังกฤษในแบบที่ถูกต้อง",
        LINE_1: "เราเล็งเห็นปัญหาที่น้องๆ หลายคนเจอในการเรียนภาษาอังกฤษ",
        LINE_2: "คือการท่องจำที่ไม่เข้าใจหลายครั้งวิธีเรียนแบบเดิมๆ",
        LINE_3: "แต่ที่นี่ต่างออกไป! เพราะครูของเราไม่เพียงแค่เป็นผู้สอน",
        LINE_4:
          "ที่มีประสบการณ์กว่า 10 ปี แต่เข้าใจปัญหาที่น้องๆ กำลังเผชิญอยู่",
        LINE_5: "เราได้สรุปและสร้างเทคนิคทำให้ภาษาอังกฤษกลายเป็นเรื่องง่าย",
        LINE_6: "ไม่ใช่แค่ท่องจำ",
        LINE_7: "เราอยากให้น้องๆให้โอกาสตัวเอง",
        LINE_8: "ได้ลองเรียนรู้ภาษาอังกฤษในแบบที่ถูกต้อง",
      },
      TEACHER: {
        TITLE: "คุณครูของเรา",
        FULLNAME: "พีรวิชญ์ แสงจันทร",
        NICKNAME: "พี่พี",
      },
    },
    PURCHASE_ORDER: {
      TITLE: "คำสั่งซื้อของฉัน",
      ORDER_DETAILS: "รายละเอียดคำสั่งซื้อ",
    },
    COURSES: {
      RECOMMEND_COURSE: "คอร์สแนะนำ",
      ALL_COURSE: "คอร์สเรียนทั้งหมด",
      ORDER_DETAILS: "รายละเอียดคำสั่งซื้อ",
    },
    ONLINE_CLASS: {
      LASTED_CLASS: "เข้าเรียนล่าสุด",
      LASTED: "ล่าสุดเมื่อ",
      CHAPTER: "chapter",
      DURATION_TIME: "เวลาทั้งหมด",
      SPENT_TIME: "เวลาที่ใช้ไป",
      USABLE_TIME: "เวลาคงเหลือ",
      STUDY_TIME: "เวลาเรียน",
      EXPIRE_DATE: "วันหมดอายุ",
      ENTER_CLASS: "เข้าสู่คอร์สเรียน",
      MY_COURSE: "คอร์สเรียนของฉัน",
      NO_ITEM: "ไม่พบรายการ",

      ACTIVATE_COURSE: "เปิดใช้งาน",
      PROGRESS: "ความคืบหน้า",
      NO_EXPIRE: "ไม่จำกัด",
      PAUSE_CLASS: "พักการเรียนชั่วคราว",

      ABOUT_COURSE: "เกี่ยวกับบทเรียน",
      PDF_FILE: "  ไฟล์เอกสาร PDF",

      EXERCISE: "แบบฝึกหัด",
      EXAMINATION: "ข้อสอบ / แบบทดสอบ",
      NO_DOC: "ไม่มีเอกสาร",

      START: "เริ่มทำ",
      REPEAT: "ทำอีกครั้ง",
      ANALYSIS: "วิเคราะห์",
      NO_EXAM: "ไม่มีบททดสอบ",

      COMMENT_TITLE: "ให้คะแนนและความคิดเห็นของคุณเกี่ยวกับคอร์สนี้",
      COMMENT_PLACEHOLDER: "ระบุความคิดเห็นของคุณที่นี่...",
      COMMENT_SUBMIT: "ส่งความคิดเห็น",
      COMMENT_RATING: "ให้คะแนน",
      COMMENT_SUCCESS: "รีวิวเรียบร้อย",

      COURSE_TIMEOUT: "เวลาเรียนของท่านหมดลงแล้ว",
      ACTIVE_CONFIRM: "ยืนยันการเปิดคอร์สเรียน",
      ACTIVE_CONFIRM_DESC: "คุณต้องการเปิดคอร์สเรียนนี้ใช่หรือไม่?",

      STOP_EXAM: "ยกเลิกทำข้อสอบ",
      ANSWER_DESC: "เฉลย และอธิบายคำตอบ",
      ANSWER_PLACEHOLDER: "กรอกคำตอบของคุณที่ช่องนี้...",
      ANSWER_SUBMIT: "ส่งคำตอบ",

      ANS_EQUAL: "คำตอบ คือ",
      SOLUTION_NO: "วิธีแก้ปัญหาที่",
      RESOLVE_BY: "เฉลยโดย",

      RESULT: "ผลการทดสอบ",
      ENTER_SOLUTION: "ดูเฉลย",
      OVERALL: "ภาพรวม",

      TIMEUP_DIALOG_TITLE: "หมดเวลาการทำข้อสอบ !",
      TIMEUP_DESC_1: "หมดเวลาการทำข้อสอบของชุดข้อสอบนี้แล้ว",
      TIMEUP_DESC_2: 'กรุณากด "ยืนยัน" เพื่อทำการส่งคำตอบ',
    },
    BLOG: {
      FILTER: {
        CATEGORY: "หมวดหมู่",
        SEARCH: "ค้นหา",
        SEARCH_PLACEHOLDER: "ค้นหา...",
      },
    },
    AUTH: {
      WELCOME_TEXT: "ยินดีต้อนรับสู่",
      UNAUTHORIZED_ALERT: "กรุณาลงชื่อเข้าใช้ก่อนใช้งาน",
      USERNAME: "ชื่อผู้ใช้งาน",
      EMAIL: "อีเมล",
      PASSWORD: "รหัสผ่าน",
      FORGOT_PASSWORD: "ลืมรหัสผ่าน?",
      NOT_REGISTER: "ยังไม่มีบัญชีเข้าใช้?",
      ALREADY_REGISTER: "มีบัญชีเข้าใช้แล้ว?",
      SIGN_IN: "เข้าสู่ระบบ",
      SIGN_UP: "ลงทะเบียน",
      SUBMIT_SIGN_UP: "ยืนยันลงทะเบียน",
      SIGN_OUT: "ออกจากระบบ",
      SIGN_INING: "กำลังเข้าสู่ระบบ",
      INVALID_LOGIN:
        "ชื่อผู้ใช้หรือรหัสผ่านที่คุณป้อนไม่ถูกต้อง โปรดตรวจสอบและลองอีกครั้ง",
      INVALID_VERIFY:
        "ชื่อผู้ใช้หรือรหัสผ่านที่คุณป้อนไม่ถูกต้อง หรือไม่มีสิทธิ์ในการใช้งาน โปรดตรวจสอบและลองอีกครั้ง",
      GENERAL: {
        OR: "Or",
        SUBMIT_BUTTON: "Submit",
        NO_ACCOUNT: "Don't have an account?",
        SIGNUP_BUTTON: "Sign Up",
        FORGOT_BUTTON: "Forgot Password",
        BACK_BUTTON: "Back",
        PRIVACY: "Privacy",
        LEGAL: "Legal",
        CONTACT: "Contact",
      },
      LOGIN: {
        TITLE: "Login Account",
        BUTTON: "Sign In",
      },
      FORGOT: {
        TITLE: "Forgotten Password?",
        DESC: "Enter your email to reset your password",
        SUCCESS: "Your account has been successfully reset.",
      },
      REGISTER: {
        TITLE: "ลงทะเบียน",
        DESC: "Enter your details to create your account",
        SUCCESS: "Your account has been successfuly registered.",
        NOT_REGISTER: "ยังไม่มีบัญชีใช่หรือไม่?",
      },
      INPUT: {
        EMAIL: "Email",
        FULLNAME: "Fullname",
        PASSWORD: "รหัสผ่าน",
        CONFIRM_PASSWORD: "ยืนยันรหัสผ่าน",
        USERNAME: "Username",
      },
      VALIDATION: {
        INVALID: "{{name}} is not valid",
        REQUIRED: "{{name}} is required",
        MIN_LENGTH: "{{name}} minimum length is {{min}}",
        AGREEMENT_REQUIRED: "Accepting terms & conditions are required",
        NOT_FOUND: "The requested {{name}} is not found",

        INVALID_LOGIN:
          "ชื่อผู้ใช้หรือรหัสผ่านที่คุณป้อนไม่ถูกต้อง โปรดตรวจสอบและลองอีกครั้ง",
        REQUIRED_FIELD: "Required field",
        MIN_LENGTH_FIELD: "Minimum field length:",
        MAX_LENGTH_FIELD: "Maximum field length:",
        INVALID_FIELD: "Field is not valid",
      },
    },

    COMPONENT: {
      ADD: "เพิ่ม",
      CREATE: "สร้าง",
      EDIT: "แก้ไข",
      DELETE: "ลบออก",
      VIEW_DATA: "ดูข้อมูล",
      DOWNLOAD: "ดาวน์โหลด",
      UPLOAD: "อัปโหลด",
      BROWSE_FILE: "เลือกไฟล์",
      PRINT: "พิมพ์",
      SAVE: "บันทึก",
      SAVE_DRAFT: "บันทึกแบบร่าง",
      VIEW_DETAIL: "ดูรายละเอียด",
      SAVE_CHANGES: "บันทึกการเปลี่ยนแปลง",
      NEW_EVENT: "สร้างกิจกรรมใหม่",
      CONFIRM: "ยืนยัน",
      ACCEPT: "ตอบรับ",
      REJECT: "ปฏิเสธ",
      DISAPPROVE: "ไม่อนุมัติ",
      APPROVE: "อนุมัติ",
      APPROVED: "ผ่านการตรวจสอบ",
      CONFIRM_REJECT: "ยืนยืนปฏิเสธ",
      CONFIRM_DISAPPROVE: "ยืนยันส่งแก้ไข",
      SUBMIT: "ส่ง",
      VIEW_COMMENT: "ดูความคิดเห็น",
      APPROPRIATE: "เหมาะสม",
      MUST_REVISE: "ต้องแก้ไข",
      SEND_EMAIL: "ส่งอีเมล",
      ISSUE_A_CERTIFICATE: "ออกใบรับรอง",
      CANCEL: "ยกเลิก",
      CLOSE: "ปิด",
      NEXT: "ถัดไป",
      IMPORT_DATA: "นำเข้าข้อมูล",
      FILE_FORMAT: "รูปแบบไฟล์",
      NEW: "สร้างใหม่",
      IMPORT: "นำเข้า",
      REMOVE: "ลบออก",
    },
    VALIDATOR: {
      EMAIL:"รูปแบบไม่ถูกต้อง",
      REQUIRED: "กรุณากรอกข้อมูล",
      REQUIRED_DATE: "กรุณากรอกข้อมูลตั้งแต่ 1 วันขึ้นไป",
      MUST_BE_AT_LEAST_X_CHARACTERS: "จำนวนตัวอักษรอย่างน้อย {{value}} ตัว",
      MUST_CONTAIN_AT_LEAST_X_LETTER_IN_LOWER_CASE:
        "ตัวพิมพ์เล็ก [a-z] อย่างน้อย {{value}} ตัว",
      MUST_CONTAIN_AT_LEAST_X_LETTER_IN_UPPER_CASE:
        "ตัวพิมพ์ใหญ่ [A-Z] อย่างน้อย {{value}} ตัว",
      MUST_CONTAIN_AT_LEAST_X_NUMBER: "ตัวเลข [0-9] อย่างน้อย {{value}} ตัว",
      INVALID_EMAIL: "กรุณากรอกอีเมลที่ถูกต้อง",
      PASSWORD_MISMATCH: "รหัสผ่านไม่ตรงกัน",
      PASSWORD_INVALID: "รูปแบบ 'รหัสผ่าน' ไม่ถูกต้อง",
      PLEASE_SELECT: "กรุณาเลือก",
      PLEASE_SELECT_TIME_SLOTS: "กรุณาเลือกช่วงเวลา",
      PLEASE_SELECT_FILE: "กรุณาเลือกไฟล์",
      PLEASE_ADD_ALL_DOCUMENTS: "กรุณาเพิ่มเอกสารให้ครบทุกหัวข้อ",
      DUPLICATE_DOC_NO: "เลขที่เอกสารมีในระบบแล้วกรุณากรอกใหม่",
      MUST_MATCH: "รหัสผ่านใหม่และยืนยันรหัสผ่านใหม่ต้องเหมือนกัน",

      ERROR: "ผิดพลาด",
      SOMETHING_ERROR: "เกิดข้อผิดพลาด",
      CHANGE_PASSWORD_SUCCESS: "เปลี่ยนรหัสผ่านสำเร็จ",
      CHANGE_PASSWORD_DUPLICATED:
        "ไม่สามารถใช้รหัสผ่านใหม่ที่เหมือนกับรหัสผ่านเก่า",
      CHANGE_PASSWORD_INVALID: "รหัสผ่านเก่าไม่ถูกต้อง",
      CHANGE_PASSWORD_ERROR: "มีข้อผิดพลาดกรุณาตรวจสอบ",
    },
    SWEETALERT: {
      CONFIRMATION_TITLE: "การยืนยัน",
      CONFIRMATION_TEXT: "คุณแน่ใจหรือว่าต้องการดำเนินการต่อ?",
      CONFIRMATION_DELETE_TEXT: "คุณแน่ใจหรือว่าต้องการลบสิ้งนี้?",
      CONFIRMATION_SAVE_TITLE: "ยืนยันบันทึก",
      CREATE_DATA: "สร้างข้อมูล",
      CREATE_DATA_TEXT: "คุณแน่ใจหรือว่าต้องการสร้างข้อมูลนี้?",
      UPDATE_DATA: "อัปเดตข้อมูล",
      UPDATE_DATA_TEXT: "คุณแน่ใจหรือว่าต้องการอัปเดตข้อมูลนี้?",
      SUCCESS_TITLE: "สำเร็จ",
      SUCCESS_TEXT: "สร้างข้อมูลใหม่เรียบร้อยแล้ว",
      SUCCESS_TEXT_UPDATE: "ข้อมูลได้อัปเดตเรียบร้อยแล้วแล้ว",
      SUCCESS_TEXT_DELETE: "ข้อมูลได้ถูกลบเรียบร้อยแล้ว",
      ERROR_TITLE: "ไม่สำเร็จ",
      ERROR_TEXT: "ดูเหมือนว่ามีบางอย่างผิดพลาด",
      WARNING_TITLE: "คำเตือน",
      WARNING_TEXT: "มีบางอย่างไม่ถูกต้อง อาจทำให้คุณไม่สามารถดำเนินการต่อได้",
      WARNING_IMAGE_SIZE_TITLE: "รูปภาพมีขนาดใหญ่เกินไป",
      WARNING_IMAGE_SIZE_TEXT:
        "กรุณาตรวจสอบขนาดรูปภาพต้องไม่เกิน {{value}} {{unit}}.",

      ERROR_APPROVER_DUPLICATE_OWNER: "ผู้ขอไม่สามารถเป็นผู้รับรองได้",
      ERROR_COMMITTEE_DUPLICATE: "ท่านได้เลือกกรรมการท่านนี้แล้ว",
      ERROR_COMMITTEE_EXTERNAL: "กรรมการภายนอกมีได้ไม่เกิน 1 คน",
      ERROR_COMMITTEE_INTERNAL: "กรรมการภายในมีได้ไม่เกิน 2 คน",

      ERROR_NOTFOUND_DOC: "ไม่พบหมายเลขเอกสาร",
      ERROR_NOTFOUND_DOC_BY_NAME: "ไม่พบชื่อ-สกุลที่ค้นหา",
      ERROR_REQUIRED: "กรุณากรอกข้อมูลให้ครบ",
      PROCESSING_TITLE: "ระบบกำลังทำรายการ",
      PROCESSING_TEXT: "กรุณารอสักครู่..",
    },
    MISC: {
      HELLO: "สวัสดี",
      ASSOC_PROF: "ผู้ช่วยศาสตราจารย์",
    },
    TABLE: {
      NO_DATA_DISPLAY: "ไม่มีรายการแสดง",
      NO_DATA: "ไม่มีรายการ",
      TOTAL: "รวม",
      SUMMARY_TOTAL: "รวมทั้งหมด",
      TOTAL_RESULT: "ทั้งหมด",
      TOTAL_LIST: "รายการ",
      CUSTOMER_PATIENT: "ลูกค้า / ผู้ป่วย",
      AGE: "อายุ",
      AGE_YEAR: "อายุ (ปี)",
      ID: "เลขที่ประจำตัวบัตรประชาชน",
      PHONE: "เบอร์ติดต่อ",
      EMERGENCY: "ฉุกเฉิน",
      LINE: "LINE",
      LAST_UPDATED: "แก้ไขล่าสุด",
      LAST_LOGIN: "เข้าสู่ระบบล่าสุด",
      OPTION: "ตัวเลือก",
      BY: "by",
      CONNECTED: "เชื่อมต่อแล้ว",
      NOT_CONNECTED: "ไม่ได้เชื่อมต่อ",
      DOC_NO: "เลขที่",
      DATE: "วันที่",
      SUB_TOTAL: "ราคารวม",
      NET_PRICE: "ยอดรวม",
      PAID_PRICE: "ยอดที่ต้องชำระ",
      STATUS: "สถานะ",
      PAID: "ชำระแล้ว",
      REFERENCE: "อ้างอิงจาก",
      ISSUED_BY: "ออกให้โดย",
      ITEMS: "รายการ",
      PRICE_PER_UNIT: "ราคา/หน่วย",
      AMOUNT: "จำนวน",
      DISCOUNT: "ส่วนลด",
      BAHT: "บาท",
      MEDICINE_USAGE: "การใช้ยา",
      VAT: "ภาษีมูลค่าเพิ่ม ({{value}})",
      SERVICE_DATE: "วันที่รับบริการ",
      COMPLETED_DATE: "วันที่รับบริการเสร็จสิ้น",
      EXAMINATION_ROOM: "ห้องตรวจรักษา",

      // REPORT
      RECEIPT_NO: "เลขที่ใบเสร็จ",
      APPOINTMENT: "นัดหมาย",

      // SETTING
      CODE: "รหัส",
      PRICE: "ราคา",
      UNIT: "หน่วย",
      NUMBER_OF_MEDICINE: "จำนวนรายการยา",
      ACCOUNT_NAME: "ชื่อบัญชี",
      ACCOUNT_NO: "เลขที่บัญชี",
      USED_FOR: "ใช้สำหรับ",
      NAME: "ชื่อ",
      NAME_CODE: "ชื่อ / รหัส",
      LICENSE_NO: "เลขที่ใบอนุญาต",
      EMAIL: "อีเมล",
      ROLE: "บทบาท",
      DESCRIPTION: "คำอธิบาย",
      GROUP: "กลุ่ม",
      CATEGORY: "หมวดหมู่",
      TYPE: "ประเภท",
      UNIT_NAME: "ชื่อหน่วยนับ",
      PRIMARY_UNIT: "หน่วยหลัก",
      MULTIPILIER: "อัตรา/หน่วย",
      TIMES: "จำนวนครั้ง",
      SELL_PRICE: "ราคาขาย",
      TYPE_OF_SERVICE: "ลักษณะการให้บริการ",
      SHOW: "แสดง",
      ENTRIES: "รายการ",
      SEARCH: "ค้นหา",

      // REPORT
      OWNER_NAME: "ชื่อผู้ยื่น",
      Q_TIMES: "ครั้ง",
      Q_PEOPLE: "คน",

      PAGINATION_LIMIT_SHOWING:
        "แสดง {{start_value}} - {{end_value}}  จากทั้งหมด  {{total_value}} รายการ",
    },
    GLOBAL: {
      DOWNLOAD_FORM:"ดาวน์โหลดแบบฟอร์ม",
      IMPORT_DATA:"นำเข้าข้อมูล",
      ADD_DATA:"เพิ่มรายการใหม่",
      ACCESSORIES: "อุปกรณ์ตกแต่ง",
      ACTUAL_PAY: "จ่ายจริง",
      ALL: "ทั้งหมด",
      ALL_JOB_NO: "เลขที่ Job",
      AS_PERCENT: "% ของ",
      AVG_CAR: "เฉลี่ย/คัน",
      AVG_DC: "ส่วนลดเฉลี่ย",
      BACK: "ย้อนกลับ",
      BACK_ORDER: "Back Order",
      BILL: "บิล",
      BPE_NO: "เลขที่ BPE",
      BRAND: "ยี่ห้อ",
      BRANCH: "สาขา",
      BRANCH_CODE: "รหัสสาขา",
      CANCELED_JOB_INT: "ยกเลิก Job (INT)",
      CANCELED_JOB_REPAY: "ยกเลิก Job (คืนเงิน)",
      CANCELED_RECEIPT: "ยกเลิกใบเสร็จ",
      CANCELED_RECEIPT_CASH: "ยกเลิกใบเสร็จ (เงินสด)",
      CANCELED_RECEIPT_CREDIT: "ยกเลิกใบเสร็จ (เครดิต)",
      CAR: "รถ",
      CAR_AMOUNT: "จำนวนรถ",
      CAR_COUNT: "จำนวนคัน",
      CAR_OVER_3_YEAR: "รถเกิน 3 ปี",
      CAR_YEAR: "รถปี",
      CARS: "รถ",
      CASH: "เงินสด",
      CASH_DETAIL: "รายละเอียดเงินสด",
      CLAIM_JOB: "งานเคลม",
      CLAIM_NO: "เลขที่เคลม",
      CLAIM_TYPE: "ประเภทเคลม",
      CLEAR: "ล้าง",
      CREDIT: "เครดิต",
      CREDIT_RECEIVED: "รับชำระเครดิต",
      CUSTOMER: "ลูกค้า",
      CUSTOMER_CODE: "รหัสลูกค้า",
      CUSTOMER_TYPE: "ประเภทลูกค้า",
      DATE: "วันที่",
      DAY: "วัน",
      DEALER_CODE: "รหัสตัวแทน",
      DEBTOR: "ลูกหนี้ GS",
      EXCEL: "Excel",
      FILE: "ไฟล์",
      FINISHED: "เสร็จสิ้น",
      INSURANCE: "ประกันภัย",
      INSURANCE_DETAIL: "รายละเอียดประกันภัย",
      INSURANCE_VALUE: "มูลค่าประกันภัย",
      INT_DOC_DATE: "วันที่เอกสาร INT",
      INT_DOC_NO: "เลขที่เอกสาร INT",
      INTERNAL_JOB: "Job ภายใน",
      ITEMS: "รายการ",
      JOB_AMOUNT: "จำนวน Job",
      JOB_CANCEL: "Job ยกเลิก",
      JOB_CLOSE: "Job ปิด",
      JOB_CLOSE_BILL: "Job ปิด (ออก Invoice)",
      JOB_CLOSE_DATE: "วันที่ปิด Job",
      JOB_CLOSE_NO_BILL: "Job ปิด (ยังไม่ออก Invoice)",
      JOB_COUNT: "จำนวน Job",
      JOB_DATE: "วันที่ Job",
      JOB_MOVEMENT: "Job เคลื่อนไหว",
      JOB_NO: "เลขที่ Job",
      JOB_OPEN: "Job เปิด",
      JOB_STATUS: "สถานะ Job",
      JOB_TYPE: "ประเภท Job",
      JOB_VALUE: "มูลค่า Job",
      JOBS: "Job",
      JOBS_FINISHED: "งานปิดและรับชำระ",
      JOBS_SUMMARY: "สรุปรายการ Jobs",
      JOBS_WV: "งาน W/V",
      KEYWORDS: "คำค้นหา",
      LABOR_DC: "ส่วนลดค่าแรง",
      LABOUR_COST: "ต้นทุนค่าแรง",
      LABOUR_SALE: "ค่าแรงขาย",
      MONEY: "เงิน",
      MONEY_WV: "เงิน W/V",
      MONTH_YEAR: "เดือน/ปี",
      NEW_IMPORT: "นำเข้าใหม่",
      NO_RESULT: "ไม่พบข้อมูล",
      NON_VM: "ไม่เป็น VM",
      OIL_COST_TYPE_O: "ต้นทุนน้ำมัน (O)",
      OIL_SALE_TYPE_O: "น้ำมันขาย (O)",
      OTHER_BRAND: "ยี่ห้ออื่น",
      OUTSIDE_COST: "ต้นทุนภายนอก",
      OUTSIDE_SALE: "ภายนอกขาย",
      PART_COST: "ต้นทุนอะไหล่",
      PART_RETURN: "คืนอะไหล่",
      PART_SALE: "อะไหล่ขาย",
      PARTS_DC: "ส่วนลดอะไหล่",
      PARTS_JOB: "งานอะไหล่",
      PAY_TYPE: "ประเภทการชำระ",
      PENDING_CAR: "รถค้าง",
      PRICE: "ราคา",
      PRINT: "พิมพ์",
      RECEIVED_BALANCE_AND_CREDIT_RECEIVED: "ยอดรับเงินและยอดชำระหนี้",
      REFRESH: "รีเฟรช",
      REG_NO: "เลขทะเบียน",
      REP: "REP",
      REPAY: "คืนเงิน",
      REPAY_LIST: "รายการคืนเงิน",
      ROUND_AMOUNT: "ยอดปัด",
      SEARCH_OPTIONS: "ตัวเลือกค้นหา",
      SERIE: "รุ่น",
      SPECIAL_DISCOUNT: "ส่วนลดพิเศษ",
      STATS: "สถิติ",
      SUMMARY: "สรุป",
      TAX_INV_DATE: "วันที่ใบกำกับ",
      TAX_INV_NO: "เลขที่ใบกำกับ",
      TAX_INVOICE: "ใบกำกับภาษี",
      TOTAL: "รวม",
      TOTAL_COST: "ต้นทุนรวม",
      TOTAL_INCOME: "รายได้รวม",
      TOTAL_RECEIVED: "ยอดรับ",
      TOTAL_SUM: "ยอดรวม",
      TOTAL_SUM_PC: "% ยอดรวม",
      TOYOTA_BRAND: "Toyota Brand",
      VAT7: "ภาษี 7%",
      VIN_NO: "เลขตัวถัง",
      CUSTOMER_NAME: "ชื่อลูกค้า",
      CSV: "CSV",
      JOB_DETAIL: "รายละเอียด Job",
      MILEAGE: "เลขไมล์",
      VEHICLE_SOLD_DATE: "วันที่ขายรถ",
      SA_NAME_OPEN_JOB: "ชื่อ SA (เปิดงาน)",
      SA_CODE_OPEN_JOB: "รหัส SA (เปิดงาน)",
      DATE_PERIOD: "ช่วงวันที่",
      BILL_TYPE: "ประเภทบิล",
      TAX_TYPE: "ประเภทภาษี",
      BILL_AMOUNT: "ยอดบิล",
      VAT_AMOUNT: "VAT",
      PARTS_JOB_DETAIL: "รายละเอียดงานอะไหล่",
      RECEIPT_DATE: "วันที่ใบเสร็จ",
      REFER: "อ้างอิง",
      PART_PO: "Part PO",
      PENDING_JOB_WAIT_PART: "งานค้างรออะไหล่",
      RESV_NO_SOP: "เลขที่จอง (SOP)",
      RESERVED_DATE: "วันที่จอง",
      ORDER_DATE: "วันที่สั่ง",
      PO_NO: "เลขที่ PO",
      ORDER_TYPE: "ประเภทคำสั่งซื้อ",
      PART_NAME: "ชื่ออะไหล่",
      ETA: "ETA",
      BO_QTY: "จำนวน BO",
      OUTLAY: "จ่ายออก",
      PENDING_JOB_TRACKING: "ติดตามงานค้าง",
      FILE_STATUS_REPORT: "รายงานสถานะอัพโหลดไฟล์",
      UNCOMPLETE: "ไม่ครบ",
      COMPLETE: "ครบ",
      DEBTOR_GROUP: "กลุ่มลูกหนี้",
      ADD_GROUP: "เพิ่มกลุ่ม",
      DEBTOR_NAME: "ชื่อลูกหนี้",
      CREDIT_DEBTOR_DETAIL: "รายละเอียดลูกหนี้เครดิต",
      COMPANY_DEBTOR: "ลูกหนี้บริษัท",
      CUSTOMER_ID: "รหัสลูกค้า",
      NO_GROUP: "ไม่มีกลุ่ม",
      COMPANY_DETAIL: "รายละเอียดบริษัท",
      COMPANY_NAME_TH: "ชื่อบริษัท (ภาษาไทย)",
      COMPANY_ADDRESS_TH: "ที่อยู่บริษัท (ภาษาไทย)",
      CONTACT_NAME_TH: "ชื่อผู้ติดต่อ (ภาษาไทย)",
      FINANCIAL_AMOUNT: "วงเงิน",
      PAYMENT_SCHEDULE: "กำหนดชำระ",
      BILLING_DATE: "วันที่วางบิล",
      FIRST_CONTACT_DATE: "วันที่ติดต่อครั้งแรก",
      SELL_TARGET: "เป้าขาย",
      CHART_OF_AMOUNT_CODE: "รหัสบัญชี",
      PRICE_A_Z: "ราคา (A-Z)",
      SA_CODE: "รหัส SA",
      DRAG_AND_DROP_FILE_HERE: "ลากและวางไฟล์ที่นี่",
      BROWSE_FILES: "เลือกไฟล์",
      UPLOAD_QUEUE: "คิวอัปโหลด",
      UPLOAD_PROGRESS: "กำลังอัปโหลด",
      REMOVE_ALL: "ลบทั้งหมด",
      STAFFS: "พนักงาน",
      STAFF_CODE: "รหัสพนักงาน",
      DEALER: "ตัวแทนจำหน่าย",
      LINE_NOTIFY_SETTING: "ตั้งค่า Line แจ้งเตือน",
      DATA_FILTER: "ตัวกรองข้อมูล",
      NOTIFY_TO: "แจ้งเตือนไปยัง",
      LINE_ROOM: "ห้อง Line",
      DAY_TIME: "วัน / เวลา",
      TOKEN: "Token",
      TOPIC: "หัวข้อ",
      PENDING_JOB_LOCATION_SETTING: "ตัวเลือกติดตามงานค้าง",
      CAR_LOCATION: "ตำแหน่งรถ",
      OPTION_LIST: "รายการตัวเลือก",
      ADD_NEW: "เพิ่มใหม่",
      DEBTOR_JOB_STATUS_MASTER_SETTING: "ตัวเลือกติดตามลูกหนี้",
      STATUS: "สถานะ",
      SERIES_CODE: "รหัสรุ่นรถ",
      SERIES: "รุ่นรถ",
      TOYOTA: "โตโยต้า",
      OPTION: "ตัวเลือก",
      OR: "หรือ",
      FIRST_NAME: "ชื่อ",
      LAST_NAME: "นามสกุล",
      SELECT: "-- เลือก --",
      UPLOADING: "กำลังอัปโหลด",
      REMOVE_TYPE: "ประเภทการลบ",
      DEALER_LABEL: "Dealer",
      BRANCH_LABEL: "สาขา",
      DEPARTMENT_LABEL: "แผนก",
      ALL_SELECTION: "ทั้งหมด",
      DEFAULT_DEALER: "ตัวแทนจำหน่ายตั้งต้น",
      DEFAULT_BRANCH: "สาขาตั้งต้น",
      ROLE: "สิทธิ์การใช้งาน",
      NICK_NAME: "ชื่อเล่น",
      EMPLOYEE_ID: "รหัสพนักงาน",
      USER_NAME: "ชื่อผู้ใช้",
      SERIES_SETTING: "ตั้งค่ารุ่นรถ",
    },
    IMPORT: {
      DAILY_IMPORT: "นำเข้ารายวัน",
      AFI_FILES: "ไฟล์ AFI",
      AFC_FILES: "ไฟล์ AFC",
      ACP_FILES: "ไฟล์ ACP",
      FILE_STATUS: "สถานะไฟล์",
      FILE_TYPE: "ประเภทไฟล์",
      FILE_NAME: "ชื่อไฟล์",
      FILE_SIZE: "ขนาดไฟล์",
      STATUS: "สถานะ",
      UPLOAD: "อัปโหลด",
      UPLOAD_DATE: "วันที่อัปโหลด",
      PROCESS_DATE: "วันที่ประมวลผล",
      RECORDS_TOTAL: "รายการทั้งหมด",
      RECORDS_SUCCESS: "สำเร็จ",
      RECORDS_FAILED: "ล้มเหลว",
      UPLOADED_BY: "อัปโหลดโดย",
      DATE_FROM: "ตั้งแต่",
      DATE_TO: "ถึง",
      LAST_IMPORT_DATE: "นำเข้าล่าสุด",
      LAST_IMPORT_STATUS: "สถานะล่าสุด",
      TOTAL_FILES: "ไฟล์ทั้งหมด",
      PENDING_FILES: "รอดำเนินการ",
      JOB_COUNT: "จำนวน Job",
      NEW_IMPORT: "นำเข้าใหม่",
      IMPORT_DATE: "วันที่นำเข้า",
      UPLOADED: "อัปโหลดแล้ว",
      NOT_UPLOADED: "ยังไม่อัปโหลด",
      FILE_DETAIL: "รายละเอียดไฟล์",
      FILE_ITEMS: "รายการข้อมูล",
      TOTAL_RECORDS: "จำนวนรายการ",
      UPLOAD_FILE: "อัปโหลดไฟล์",
      DRAG_DROP_FILE: "ลากและวางไฟล์ที่นี่",
      OR_CLICK_TO_SELECT: "หรือคลิกเพื่อเลือกไฟล์",
      ACCEPTED_TYPES: "ประเภทไฟล์ที่รองรับ",
    },
    PENDING_JOB: {
      TITLE: "งานค้างซ่อม",
      D1: "D1",
      D2_D7: "D2-D7",
      D8_D14: "D8-D14",
      D15_D30: "D15-D30",
      D30_PLUS: ">D30",
      DAY_RANGE: "ช่วงวัน",
      BACK_ORDER_NO: "Back Order No",
      PENDING_JOB_TRACKING: "ติดตามงานค้างซ่อม",
      SA_OPEN_JOB: "SA เปิดงาน",
      SA_CLOSE_JOB: "SA ปิดงาน",
      CUSTOMER_NAME: "ชื่อลูกค้า",
      NO_BP_TO_GS: "ไม่รวม BP ส่ง GS",
      ONLY_BP_TO_GS: "เฉพาะ BP ส่ง GS",
      PENDING_JOB_SUMMARY: "สรุปงานค้างซ่อม",
      REMOVE_PENDING_JOB: "งานที่ถูกลบออก",
      PENDING_JOB_COUNT: "จำนวนงานค้างซ่อม",
      CAR_COUNT: "จำนวนรถ",
      LABOUR: "ค่าแรง",
      PART: "ค่าอะไหล่",
      EXTERNAL: "งานนอก",
      OIL: "น้ำมัน",
      SPECIAL_DISCOUNT: "ส่วนลดพิเศษ",
      TOTAL: "รวม",
      AVG_PER_CAR: "Avg./คัน",
      EXCEL_ALL: "Excel ทั้งหมด",
      PRINT_ALL: "พิมพ์ทั้งหมด",
      VM_ALL: "ทั้งหมด",
      NON_VM: "ไม่เป็น VM",
      OPERATOR: "ผู้ดำเนินการ",
    },
    JOB_CREDIT_REP: {
      TITLE: "ลูกค้าเครดิต (REP)",
      CUSTOMER_LIST: "รายการลูกค้า",
      REMOVED_CUSTOMER_LIST: "รายการลูกค้าที่ถูกลบ",
      D1_D15: "D1-D15",
      D16_D30: "D16-D30",
      D31_D45: "D31-D45",
      D46_D90: "D46-D90",
      D90_PLUS: ">D90",
      INSURANCE_CODE: "รหัสบริษัทประกันภัย",
      INSURANCE_NAME: "ชื่อบริษัทประกันภัย",
      CUSTOMER_JOB_TRACKING: "ติดตามงานลูกค้า",
      SA_OPEN_JOB: "SA เปิดงาน",
      SA_CLOSE_JOB: "SA ปิดงาน",
      EXCEL_ALL: "Excel ทั้งหมด",
      PRINT_ALL: "พิมพ์ทั้งหมด",
      OPERATOR: "ผู้ดำเนินการ",
    },
    CUSTOMER_STATS: {
      TITLE: "สถิติลูกค้า",
      YEARLY: "รายปี",
      MONTHLY: "รายเดือน",
      SELECT_YEAR: "เลือกปี",
      SELECT_MONTH: "เลือกเดือน",
      CASH_CUSTOMER: "ลูกค้าเงินสด",
      CREDIT_CUSTOMER: "ลูกค้าเครดิต",
      INTERNAL_CUSTOMER: "ลูกค้าภายใน",
      REPAY_CUSTOMER: "ลูกค้าจ่ายคืน",
      DEBT_CODE: "รหัสลูกหนี้",
      TOTAL_SUM: "รายได้รวม",
      ALL_YEAR: "ทั้งปี",
      ALL_MONTH: "ทั้งเดือน",
      AVERAGE: "เฉลี่ย",
      INCOME_SRC: "รายได้จาก",
      LABOUR_SALE: "ค่าแรง",
      SPARE_PART: "อะไหล่",
      CHEMICAL: "เคมีภัณฑ์",
      OUTSIDE_SALE: "งานนอก",
      PART_COST_PRICE: "อะไหล่ราคาทุน",
      AVG_DISCOUNT_PC: "% ส่วนลดเฉลี่ย",
      AVG_PERIOD_DEBT_PAY: "ระยะจ่ายหนี้เฉลี่ย",
      DAY: "วัน",
      CAR_AMOUNT: "จำนวนคัน",
    },
    CREDIT_CUSTOMER: {
      TITLE: "ลูกค้าเครดิต",
      NOT_BILLING_AMOUNT: "จำนวนยังไม่วางบิล",
      TOTAL_AMOUNT: "ยอดรวม",
      ACCOUNTING_BILLING_DOC: "เลขที่เอกสารบัญชี",
    },
    ABNORMAL_CREDIT_CUSTOMER: {
      TITLE: "Job ลูกค้าเครดิตผิดปกติ",
      INSURANCE_CODE: "รหัสบริษัทประกันภัย",
      INSURANCE_NAME: "ชื่อบริษัทประกันภัย",
      SA_OPEN_JOB: "SA เปิดงาน",
      SA_CLOSE_JOB: "SA ปิดงาน",
      CUSTOMER_DETAIL: "รายละเอียดลูกค้า",
      CUSTOMER_HISTORY_DETAIL: "รายละเอียดประวัติลูกค้า",
      HISTORY: "ประวัติ",
      DETAIL_TYPE: "ประเภทรายละเอียด",
      OUTOP_CODE: "รหัส Outop",
      PART_NO: "รหัสอะไหล่",
      DETAIL: "รายละเอียด",
      PRINT_DESC: "รายละเอียดการพิมพ์",
      SRV_FILE: "ไฟล์ Srv",
      USER: "ผู้ใช้",
    },
    AFI_JOB: {
      AFI_LIST: "รายการ AFI",
      MISTAKE: "ปิดผิด",
      NO_SOLD_DATE: "ไม่มีวันที่ตัดขาย",
      WARRANTY_NEARLY_EXPIRED: "ใกล้หมดระยะรับประกัน",
      WARRANTY_EXPIRED: "เกินระยะรับประกัน",
      TMT_NOT_SENT: "ยังไม่ส่ง TMT",
      AFI_DETAIL: "รายละเอียด AFI",
      AFI_HISTORY_DETAIL: "รายละเอียดประวัติ AFI",
      HISTORY: "ประวัติ",
      SA_OPEN_JOB: "SA เปิดงาน",
      SA_CLOSE_JOB: "SA ปิดงาน",
      OUTOP_CODE: "รหัส Outop",
      WARRANTY: "รับประกัน",
      DEALER_COST: "ราคาทุน Dealer",
      DETAIL_TYPE: "ประเภทรายละเอียด",
      PART_NO: "รหัสอะไหล่",
      DETAIL: "รายละเอียด",
      PRINT_DESC: "รายละเอียดการพิมพ์",
      PAY_BY: "จ่ายโดย",
      WARRANTY_TYPE: "ประเภทรับประกัน",
      SRV_FILE: "ไฟล์ Srv",
      USER: "ผู้ใช้",
    },
    AFC_JOB: {
      AFC_LIST: "รายการ AFC",
      NO_SOLD_DATE: "ไม่มีวันที่ตัดขาย",
      WARRANTY_EXPIRED: "เกินระยะรับประกัน",
      TMT_NOT_SENT: "ยังไม่ส่ง TMT",
      AFC_DETAIL: "รายละเอียด AFC",
      AFC_HISTORY_DETAIL: "รายละเอียดประวัติ AFC",
      HISTORY: "ประวัติ",
      SA_OPEN_JOB: "SA เปิดงาน",
      SA_CLOSE_JOB: "SA ปิดงาน",
      WARRANTY: "รับประกัน",
      LABOUR_COST: "ค่าแรง",
      PART_COST: "ค่าอะไหล่",
      OUTSIDE_COST: "ค่าภายนอก",
      TOTAL: "รวม",
      DETAIL_TYPE: "ประเภทรายละเอียด",
      OUTOP_CODE: "รหัส Outop",
      PART_NO: "รหัสอะไหล่",
      DETAIL: "รายละเอียด",
      PRINT_DESC: "รายละเอียดการพิมพ์",
      PAY_BY: "จ่ายโดย",
      WARRANTY_TYPE: "ประเภทรับประกัน",
      SRV_FILE: "ไฟล์ Srv",
      USER: "ผู้ใช้",
    },
    ACP_JOB: {
      ACP_LIST: "รายการ ACP",
      NO_SOLD_DATE: "ไม่มีวันที่ตัดขาย",
      WARRANTY_EXPIRED: "เกินระยะรับประกัน",
      TMT_NOT_SENT: "ยังไม่ส่ง TMT",
      ACP_DETAIL: "รายละเอียด ACP",
      ACP_HISTORY_DETAIL: "รายละเอียดประวัติ ACP",
      HISTORY: "ประวัติ",
      SA_OPEN_JOB: "SA เปิดงาน",
      SA_CLOSE_JOB: "SA ปิดงาน",
      WARRANTY: "รับประกัน",
      LABOUR_COST: "ค่าแรง",
      PART_COST: "ค่าอะไหล่",
      OUTSIDE_COST: "ค่าภายนอก",
      TOTAL: "รวม",
      DETAIL_TYPE: "ประเภทรายละเอียด",
      OUTOP_CODE: "รหัส Outop",
      PART_NO: "รหัสอะไหล่",
      DETAIL: "รายละเอียด",
      PRINT_DESC: "รายละเอียดการพิมพ์",
      PAY_BY: "จ่ายโดย",
      WARRANTY_TYPE: "ประเภทรับประกัน",
      SRV_FILE: "ไฟล์ Srv",
      USER: "ผู้ใช้",
    },
    FRE_JOB: {
      FRE_LIST: "รายการ FRE",
      FRE_DETAIL: "รายละเอียด FRE",
      FRE_HISTORY_DETAIL: "รายละเอียดประวัติ FRE",
      HISTORY: "ประวัติ",
      SA_OPEN_JOB: "SA เปิดงาน",
      SA_CLOSE_JOB: "SA ปิดงาน",
      DEALER_COST: "ราคาทุน Dealer",
      DETAIL_TYPE: "ประเภทรายละเอียด",
      OUTOP_CODE: "รหัส Outop",
      PART_NO: "รหัสอะไหล่",
      DETAIL: "รายละเอียด",
      PRINT_DESC: "รายละเอียดการพิมพ์",
      PAY_BY: "จ่ายโดย",
      WARRANTY_TYPE: "ประเภทรับประกัน",
      SRV_FILE: "ไฟล์ Srv",
      USER: "ผู้ใช้",
    },
    CAMPAIGN_JOB: {
      ALL_JOB: "งานทั้งหมด",
      MISTAKE_JOB: "งานปิดผิด",
      CAMPAIGN_DETAIL: "รายละเอียด Campaign",
      CAMPAIGN_HISTORY_DETAIL: "รายละเอียดประวัติ Campaign",
      HISTORY: "ประวัติ",
      SA_OPEN_JOB: "SA เปิดงาน",
      SA_CLOSE_JOB: "SA ปิดงาน",
      CAMPAIGN_CODE: "รหัส Campaign",
      LABOUR_COST: "ค่าแรง",
      PART_COST: "ค่าอะไหล่",
      CHEMICAL: "เคมีภัณฑ์",
      EXTERNAL_JOB: "งานนอก",
      DETAIL_TYPE: "ประเภทรายละเอียด",
      OUTOP_CODE: "รหัส Outop",
      PART_NO: "รหัสอะไหล่",
      DETAIL: "รายละเอียด",
      PRINT_DESC: "รายละเอียดการพิมพ์",
      PAY_BY: "จ่ายโดย",
      WARRANTY_TYPE: "ประเภทรับประกัน",
      SRV_FILE: "ไฟล์ Srv",
      USER: "ผู้ใช้",
    },
    JOB_LIST: {
      JOB_HISTORY_DETAIL: "รายละเอียดประวัติ Job",
      HISTORY: "ประวัติ",
      SA_OPEN_JOB: "SA เปิดงาน",
      SA_CLOSE_JOB: "SA ปิดงาน",
      DETAIL_TYPE: "ประเภทรายละเอียด",
      OUTOP_CODE: "รหัส Outop",
      PART_NO: "รหัสอะไหล่",
      DETAIL: "รายละเอียด",
      PRINT_DESC: "รายละเอียดการพิมพ์",
      SRV_FILE: "ไฟล์ Srv",
      USER: "ผู้ใช้",
    },
    PART_JOB_LIST: {
      TITLE: "รายการงานอะไหล่",
      BILL_F_REFER: "Bill F อ้างอิง",
      BILL_V_REFER: "Bill V อ้างอิง",
      BILL_B_REFER: "Bill B อ้างอิง",
      BILL_AB_REFER: "Bill A,B อ้างอิง",
    },
    CLAIM_SUMMARY: {
      TITLE: "สรุปงานเคลม",
      CLAIM_DETAIL: "รายละเอียดเคลม",
      CLAIM_HISTORY_DETAIL: "รายละเอียดประวัติเคลม",
      SA_OPEN_JOB: "SA เปิดงาน",
      SA_CLOSE_JOB: "SA ปิดงาน",
      HISTORY: "ประวัติ",
      DETAIL_TYPE: "ประเภทรายละเอียด",
      OUTOP_CODE: "รหัส Outop",
      PART_NO: "รหัสอะไหล่",
      DETAIL: "รายละเอียด",
      PRINT_DESC: "รายละเอียดการพิมพ์",
      SRV_FILE: "ไฟล์ Srv",
      USER: "ผู้ใช้",
      SEND: "ส่ง",
      NOT_SEND: "ไม่ส่ง",
      PENDING: "ยังไม่ดำเนินการ",
    },
    INSURANCE: {
      INSURANCE_DETAIL: "รายละเอียดบริษัทประกันภัย",
      INSURANCE_CODE: "รหัสบริษัทประกันภัย",
      CREATE_INSURANCE: "สร้างบริษัทประกันภัย",
      EDIT_INSURANCE: "แก้ไขบริษัทประกันภัย",
      NO_INSURANCE_CODE: "ไม่มีรหัสบริษัทประกันภัย",
    },
    DEALER: {
      DEALER_AND_BRANCH: "ตัวแทนจำหน่าย/สาขา",
      DEALER_INFO: "ข้อมูลตัวแทนจำหน่าย",
      BRANCH_LIST: "รายการสาขา",
      COMPANY_CODE: "รหัสบริษัท",
      TOPSERV_CODE: "รหัส Topserv",
    },
    USER: {
      USERNAME: "ชื่อผู้ใช้",
      EMAIL: "อีเมล",
      ROLE: "บทบาท",
      PASSWORD: "รหัสผ่าน",
      CONFIRM_PASSWORD: "ยืนยันรหัสผ่าน",
      CREATE_USER: "สร้างผู้ใช้",
      EDIT_USER: "แก้ไขผู้ใช้",
      PASSWORD_HINT: "เว้นว่างไว้เพื่อคงรหัสผ่านเดิม",
    },
    EMAIL: {
      EMAIL_SETTING: "ตั้งค่าอีเมล",
      NAME: "ชื่อ",
      EMAIL: "อีเมล",
      SMTP_HOST: "SMTP Host",
      SMTP_PORT: "พอร์ต",
      SMTP_SETTINGS: "ตั้งค่า SMTP",
      SMTP_USERNAME: "ชื่อผู้ใช้",
      SMTP_PASSWORD: "รหัสผ่าน",
      SSL: "SSL",
      USE_SSL: "ใช้ SSL/TLS",
      IS_ACTIVE: "เปิดใช้งาน",
      ACTIVE: "เปิดใช้งาน",
      INACTIVE: "ปิดใช้งาน",
      DESCRIPTION: "คำอธิบาย",
      CREATE_EMAIL_SETTING: "สร้างการตั้งค่าอีเมล",
      EDIT_EMAIL_SETTING: "แก้ไขการตั้งค่าอีเมล",
      PASSWORD_HINT: "เว้นว่างไว้เพื่อคงรหัสผ่านเดิม",
      TEST: "ทดสอบ",
    },
    TOPSERV: {
      TOPSERV_SETTING: "ตั้งค่า Topserv",
      USERNAME: "ชื่อผู้ใช้ Topserv",
      CURRENT_PASSWORD: "รหัสผ่านปัจจุบัน",
      PASSWORD_EXPIRY_DATE: "วันหมดอายุรหัสผ่าน",
    },
    SERVER_MAINTENANCE: {
      MAINTENANCE_SETTING: "การบำรุงรักษาเซิร์ฟเวอร์",
      DATA_RETENTION: "การเก็บรักษาข้อมูล",
      DR_FILE_AGE_TOPSERV: "อายุของไฟล์ Topserv (วัน)",
      DR_DATA_AGE_TOPSERV: "อายุของข้อมูล Topserv (วัน)",
      BACKUP: "Backup",
      BU_DATE: "เวลา/ความถี่ ของ Backup (วัน)",
      BU_FILE_AGE: "อายุของ Backup (วัน)",
    },
    HEALTH_CHECK: {
      HEALTH_CHECK: "ตรวจสอบสถานะระบบ",
      OVERALL_STATUS: "สถานะโดยรวม",
      SERVICES_ONLINE: "บริการออนไลน์",
      LAST_CHECK: "ตรวจสอบล่าสุด",
      REFRESH: "รีเฟรช",
      SERVICE_LIST: "รายการบริการ",
      SERVICE_NAME: "ชื่อบริการ",
      SERVICE_NAME_PLACEHOLDER: "เช่น API Server",
      SERVICE_CODE: "รหัสบริการ",
      SERVICE_CODE_PLACEHOLDER: "เช่น api_server",
      ENDPOINT: "Endpoint",
      CHECK_INTERVAL: "ความถี่ตรวจสอบ",
      CHECK_INTERVAL_SECONDS: "ความถี่ตรวจสอบ (วินาที)",
      TIMEOUT: "Timeout",
      TIMEOUT_SECONDS: "Timeout (วินาที)",
      CHECK_SETTINGS: "ตั้งค่าการตรวจสอบ",
      IS_ACTIVE: "เปิดใช้งาน",
      ACTIVE: "เปิดใช้งาน",
      INACTIVE: "ปิดใช้งาน",
      DESCRIPTION: "คำอธิบาย",
      CREATE_SERVICE: "สร้างบริการ",
      EDIT_SERVICE: "แก้ไขบริการ",
      RESPONSE_TIME: "เวลาตอบสนอง",
      STATUS_ONLINE: "ออนไลน์",
      STATUS_OFFLINE: "ออฟไลน์",
      STATUS_WARNING: "คำเตือน",
      STATUS_UNKNOWN: "ไม่ทราบ",
    },
  },
};
